import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';

import { css, Global, Interpolation, Theme } from '@emotion/react';

import { media } from '../../services/media';

import { useStoryblokStrings } from '../../hooks/useStoryblokStrings';
import { colors } from '../../global';

export const CookieBar = () => {
    const generalString = useStoryblokStrings('general-strings');

    if (
        !generalString ||
        !generalString.cookie_button_text ||
        !generalString.cookie_message
    ) {
        return null;
    }

    return (
        <CookieConsent
            containerClasses="CookieBar"
            contentClasses="CookieBar__content"
            buttonClasses="Button Button--primary"
            buttonText={generalString.cookie_button_text}
            disableStyles
        >
            <Global styles={CookieConsentStyles} />
            {generalString.cookie_message}{' '}
            {generalString.cookie_link_url && generalString.cookie_link_text && (
                <Link to={generalString.cookie_link_url} target="_blank">
                    {generalString.cookie_link_text}
                </Link>
            )}
        </CookieConsent>
    );
};

const CookieConsentStyles: Interpolation<Theme> = (theme) => css`
    .CookieBar {
        background: rgba(0, 0, 0, 0.9);
        position: fixed;
        left: 0;
        right: 0;
        z-index: 9999999999;
        padding: 10px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        ${media.max('md')} {
            flex-direction: column;
        }

        ${media.min('md')} {
            flex-direction: row;
        }

        &__content {
            color: white;
            font-size: 14px;
            font-family: $font-family-1;
            margin-bottom: 15px;

            ${media.min('md')} {
                font-size: 16px;
                margin-bottom: 0;
                padding-right: 15px;
            }

            a {
                color: white;
            }
        }

        .Button {
            color: ${theme.version === 'upscore' ? colors.white : colors.black};
            border-radius: 50px;
            background: ${theme.version === 'upscore'
                ? colors.turquoiseGreenGradient
                : colors.white};
            padding: 10px 30px;
            font-size: 18px;
        }
    }
`;
